import React, {Component} from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

export default class JobContextMenu extends Component {
    constructor()
    {
        super();

        this.state = {
            menuAnchor: null
        };
    }

    onMenuOpenClick = (event) => {

        event.stopPropagation();

        this.setState({ menuAnchor: event.currentTarget });
    };

    onMenuItemClick = (event, action) => {

        event.stopPropagation();

        if (action)
            action();

        this.closeMenu();
    };

    onMenuClose = (event) => {
        event.stopPropagation();
        this.closeMenu();
    }

    closeMenu = () => {
        this.setState({ menuAnchor: null });
    };

    render() {
        return <div>
            <IconButton aria-label="actions" size="small" onClick={this.onMenuOpenClick}>
                <MoreHorizIcon fontSize="inherit" />
            </IconButton>
            <Menu
                anchorEl={this.state.menuAnchor}
                keepMounted
                open={Boolean(this.state.menuAnchor)}
                onClose={this.onMenuClose}>
                {this.props.menuItems?.map((item, index) =>
                    <MenuItem key={index} onClick={(event) => this.onMenuItemClick(event, item.action)}>
                    <ListItemIcon>
                        {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.text} />
                </MenuItem>
                )}
            </Menu>
        </div>;
    }
}